import { gql } from 'apollo-angular';

export const ORDER_LIST_FIELDS = gql`
  fragment OrderListFields on object_SalesOrder {
    id
    orderNumber
    orderDate
    paymentStatus
    fulfillmentStatus
    pickingTipology
    customerFirstname
    customerLastname
    totalPrice
    currency
  }
`;

export const ORDER_FIELDS = gql`
  fragment OrderFields on object_SalesOrder {
    id
    orderNumber
    orderDate
    customerFirstname
    customerLastname
    paymentStatus
    fulfillmentStatus
    #    orderHistory { FIXME
    #      event
    #      eventDate
    #    }
    paymentInfo {
      ... on fieldcollection_PaymentInfo {
        shopAmount
        shopCurrency
        customerAmount
        customerCurrency
        paymentStatus
        gateway
        paymentKind
      }
    }
    priceModifications {
      ... on fieldcollection_PriceModifications {
        name
        shopAmount
        shopCurrency
        customerAmount
        customerCurrency
      }
    }
    currency
    deliveryCompany
    deliveryStreet
    deliveryCity
    deliveryZip
    deliveryProvince
    deliveryCountry
    #    pickingTipology FIXME
    #    pickingStore { FIXME
    #      ... on object_Warehouse {
    #        name
    #        # warehouse_type
    #      }
    #    }
    customerFirstname
    customerLastname
    customerEmail
    customerStreet
    customerCity
    customerZip
    customerCompany
    customerProvince
    customerProvinceCode
    customerCountry
    totalPrice
  }
`;
